/* Funny Mask PDP v2: gallery, bundle tiers, face pickers, timer, ETA, sticky ATC. Cart drawer is the theme's own (cart-drawer.js). */
(() => {
  const $ = s => document.querySelector(s), $$ = s => [...document.querySelectorAll(s)];
  const root = $('#v2'); if (!root) return;
  const cfg = JSON.parse(root.dataset.config || '{}');
  const FACES = cfg.faces;            // [{name, img, variant}]
  const TIERS = cfg.tiers;            // {1:{variant,price,was,ship}, 3:{...}, 6:{...}?}
  const fmt = cents => new Intl.NumberFormat('en-US', {style:'currency', currency:cfg.currency || 'USD'}).format(cents / 100) + ' ' + (cfg.currency || 'USD');
  const form = $('#v2-form'), idInput = form.querySelector('[name=id]');
  form.dataset.componentCart = 'true';

  function loadVideo(v) { if (v.dataset.poster) { v.poster = v.dataset.poster; delete v.dataset.poster; } if (v.dataset.src) { v.src = v.dataset.src; delete v.dataset.src; v.load(); } }
  function loadImage(img) {
    if (img.dataset.srcset) { img.srcset = img.dataset.srcset; delete img.dataset.srcset; }
    if (img.dataset.src) { img.src = img.dataset.src; delete img.dataset.src; }
  }
  // Native image lazy-loading can fetch several screens ahead on a slow connection.
  const imageObserver = new IntersectionObserver(entries => entries.forEach(e => {
    if (e.isIntersecting) { loadImage(e.target); imageObserver.unobserve(e.target); }
  }), { rootMargin: '180px 0px' });
  $$('img[data-src]').filter(img => !img.matches('#stage > img[data-i]')).forEach(img => imageObserver.observe(img));
  // Upgrade Shopify's native wallet component only when its actual button is near view.
  // The original form, wallet markup and checkout handlers are unchanged.
  const walletSlot = $('[data-wallet-slot]');
  if (walletSlot) {
    const mountWallet = () => {
      const template = walletSlot.querySelector('template[data-wallet-template]');
      if (!template) return;
      walletSlot.appendChild(template.content.cloneNode(true));
      template.remove();
    };
    const walletObserver = new IntersectionObserver(entries => {
      if (entries.some(e => e.isIntersecting)) { mountWallet(); walletObserver.disconnect(); }
    }, { rootMargin: '250px 0px' });
    walletObserver.observe(walletSlot);
    form.addEventListener('focusin', mountWallet, { once: true });
  }
  /* gallery */
  const slides = $$('#stage [data-i]'), thumbs = $$('#thumbs button'), gd = $('#gdots');
  slides.forEach(() => gd.appendChild(document.createElement('i'))); gd.firstChild && gd.firstChild.classList.add('on');
  const FACE_SLIDE = cfg.faceSlides;  // slide index per face
  function show(i) {
    slides.forEach(s => { const on = +s.dataset.i === i; if (on && s.tagName === 'IMG') { if (s.dataset.srcset) { s.srcset = s.dataset.srcset; delete s.dataset.srcset; } if (s.dataset.src) { s.src = s.dataset.src; delete s.dataset.src; } } s.classList.toggle('on', on); if (s.tagName === 'VIDEO') { if (on) { loadVideo(s); s.play().catch(() => {}); } else s.pause(); } });
    thumbs.forEach(t => t.setAttribute('aria-current', +t.dataset.i === i ? 'true' : 'false'));
    [...gd.children].forEach((d, k) => d.classList.toggle('on', k === i));
    const tag = slides.find(s => +s.dataset.i === i); $('#stageTag').textContent = tag ? (tag.dataset.tag || '') : '';
    if (FACE_SLIDE.includes(i)) $$('.faceswap button').forEach(b => b.setAttribute('aria-pressed', FACE_SLIDE[+b.dataset.face] === i ? 'true' : 'false'));
    const t = thumbs[i]; t && t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
  }
  thumbs.forEach(t => t.addEventListener('click', () => show(+t.dataset.i)));
  gd.addEventListener('click', e => { const k = [...gd.children].indexOf(e.target); if (k >= 0) show(k); });
  $$('.faceswap button').forEach(b => b.addEventListener('click', () => { show(FACE_SLIDE[+b.dataset.face]); const first = $('.tpicks select'); if (first) { first.value = b.dataset.face; first.dispatchEvent(new Event('change', { bubbles: true })); } }));
  let sx = 0; $('#stage').addEventListener('touchstart', e => sx = e.touches[0].clientX, { passive: true });
  $('#stage').addEventListener('touchend', e => { const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) { const cur = +($('#thumbs [aria-current="true"]') || thumbs[0]).dataset.i; show((cur + (dx < 0 ? 1 : -1) + slides.length) % slides.length); } });

  /* tiers + face pickers (rendered inside the selected tier) */
  const tierOf = () => +$('input[name=tier]:checked').value;
  function renderPicks() {
    const n = tierOf();
    const prev = $$('.tpicks select').map(s => s.value);
    $$('.tpicks').forEach(t => t.innerHTML = '');
    const box = $('input[name=tier]:checked').closest('.tier').querySelector('.tpicks');
    box.innerHTML = '<div class="lbl">' + (n === 1 ? cfg.t.pickOne : cfg.t.pickMany) + '</div>';
    for (let i = 0; i < n; i++) {
      const v = prev[i] ?? (i % FACES.length);
      const row = document.createElement('div'); row.className = 'tpick';
      row.innerHTML = `<img src="${FACES[v].img}" alt="" width="34" height="34"><select aria-label="Máscara ${i + 1}" data-k="${i}">${FACES.map((f, j) => `<option value="${j}" ${j == v ? 'selected' : ''}>${f.name}</option>`).join('')}</select>`;
      row.querySelector('select').addEventListener('change', e => { row.querySelector('img').src = FACES[e.target.value].img; });
      box.appendChild(row);
    }
  }
  function syncForm() {
    const n = tierOf(), picks = $$('.tpicks select').map(s => +s.value);
    const props = form.querySelectorAll('[data-prop], [data-sku-prop]'); props.forEach(p => { p.disabled = true; p.value = ''; });
    if (n === 1) { idInput.value = FACES[picks[0] || 0].variant; }
    else {
      idInput.value = TIERS[n].variant;
      picks.forEach((v, i) => { const p = form.querySelector(`[data-prop="${i + 1}"]`); if (p) { p.disabled = false; p.value = FACES[v].name; } const skuProp = form.querySelector(`[data-sku-prop="${i + 1}"]`); if (skuProp) { skuProp.disabled = false; skuProp.value = FACES[v].sku; } });
    }
  }
  function update() {
    const n = tierOf();
    const prices = $$('.tpicks select').map(s => FACES[Number(s.value)].price).sort((a,b) => a-b);
    const freeCount = n === 6 ? 3 : n === 3 ? 1 : 0;
    const total = prices.reduce((sum,price) => sum+price,0);
    const tier = {...TIERS[n], price:prices.slice(freeCount).reduce((sum,price) => sum+price,0), was:total};
    const selectedTier = $('input[name=tier]:checked').closest('.tier');
    selectedTier.querySelector('.amt').innerHTML = fmt(tier.price) + (n > 1 ? `<s>${fmt(total)}</s>` : '');
    const each = selectedTier.querySelector('.each'); if (each) each.textContent = fmt(Math.round(tier.price/n)) + ' por máscara';
    if (walletSlot) { walletSlot.hidden = n !== 1; walletSlot.style.display = n === 1 ? "" : "none"; }
    $('#atc').disabled = prices.length !== n;
    $('#priceNow').textContent = fmt(Math.round(tier.price / n));
    $('#priceSub').innerHTML = `<b>${fmt(tier.price)}</b> por ${n} máscara${n > 1 ? 's' : ''}` + (tier.was > tier.price ? ` <s id="priceWas">${fmt(tier.was)}</s>` : '');
    const sv = tier.was - tier.price; $('#priceSave').textContent = sv > 0 ? cfg.t.save + ' ' + fmt(sv) : ''; $('#priceSave').style.display = sv > 0 ? '' : 'none';
    $('#shipLine').textContent = tier.ship ? cfg.t.shipSingle : cfg.t.shipFree;
    syncForm();
  }
  $$('input[name=tier]').forEach(r => r.addEventListener('change', () => { renderPicks(); update(); }));
  $$('.tpicks').forEach(t => t.addEventListener('change', update));
  renderPicks(); update();

  /* sticky ATC submits the same form */
  $('#stickyBtn')?.addEventListener('click', () => { syncForm(); form.requestSubmit ? form.requestSubmit() : form.submit(); });
  new IntersectionObserver(([e]) => $('#sticky').classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0), { threshold: 0 }).observe($('#atc'));
  form.addEventListener('submit', syncForm, true);

  /* Countdown restarts on each page entry, including back/forward restoration. */
  (function () {
    const sale = $('#sale'); if (!sale) return;
    const LEN = ((+sale.dataset.hours || 12) * 60 + (+sale.dataset.minutes || 34)) * 60 * 1000;
    let end = Date.now() + LEN;
    addEventListener('pageshow', event => { if (event.persisted) end = Date.now() + LEN; });
    const t = $('#timer'), z = n => String(n).padStart(2, '0');
    (function tick() { let ms = end - Date.now(); if (ms <= 0) { end = Date.now() + LEN; ms = LEN; }
      t.querySelector('[data-u=h]').textContent = z(Math.floor(ms / 36e5)); t.querySelector('[data-u=m]').textContent = z(Math.floor(ms % 36e5 / 6e4)); t.querySelector('[data-u=s]').textContent = z(Math.floor(ms % 6e4 / 1e3)); setTimeout(tick, 1000); })();
  })();

  /* delivery estimate */
  (() => { const f = d => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); const a = new Date(), b = new Date(); a.setDate(a.getDate() + (cfg.etaMin || 17)); b.setDate(b.getDate() + (cfg.etaMax || 24)); const txt = f(a) + ' to ' + f(b); $$('[data-eta]').forEach(e => e.textContent = txt); })();

  /* mini review carousel */
  (() => { const t = $('.q-track'); if (!t) return; const d = $$('.dots i'); let i = 0; setInterval(() => { i = (i + 1) % d.length; t.style.transform = `translateX(-${i * 100}%)`; d.forEach((x, k) => x.classList.toggle('on', k === i)); }, 4000); })();

  /* marquee width, header auto-hide, reveal, autoplay */
  (() => { const t = $('#barTrack'); if (!t) return; let guard = 0; while (t.scrollWidth < innerWidth * 2.2 && guard++ < 6) t.innerHTML += t.innerHTML; })();
  (() => { let last = 0; addEventListener('scroll', () => { const y = scrollY; $('#top')?.classList.toggle('hide', y > 120 && y > last); last = y; }, { passive: true }); })();
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
  $$('.reveal').forEach(el => io.observe(el));
  const vo = new IntersectionObserver(es => es.forEach(e => { const v = e.target; if (e.isIntersecting) { loadVideo(v); v.play().catch(() => {}); } else v.pause(); }), { threshold: .4 });
  $$('video[data-auto]').forEach(v => vo.observe(v));
})();
